import React, { useState } from 'react';

const NearMissForm = ({ onFormSubmit, incidentId }) => {
    const [form, setForm] = useState({
        nearMissDate: '',
        nearMissTime: '',
        location: '',
        description: '',
        reportedBy: '',
        actionsTaken: '',
        supervisor: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        if (onFormSubmit) {
            onFormSubmit(form, incidentId);
        }
        // Optionally reset form or close dialog here
        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: '0 auto' }}>
            <h2>Near Miss Report</h2>
            <div>
                <label>Date of Near Miss:</label>
                <input
                    type="date"
                    name="nearMissDate"
                    value={form.nearMissDate}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Time of Near Miss:</label>
                <input
                    type="time"
                    name="nearMissTime"
                    value={form.nearMissTime}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Location of Near Miss:</label>
                <input
                    type="text"
                    name="location"
                    value={form.location}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Description of Near Miss:</label>
                <textarea
                    name="description"
                    value={form.description}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Reported By:</label>
                <input
                    type="text"
                    name="reportedBy"
                    value={form.reportedBy}
                    onChange={handleChange}
                    required
                />
            </div>
            <div>
                <label>Actions Taken:</label>
                <textarea
                    name="actionsTaken"
                    value={form.actionsTaken}
                    onChange={handleChange}
                />
            </div>
            <div>
                <label>Supervisor Notified:</label>
                <input
                    type="text"
                    name="supervisor"
                    value={form.supervisor}
                    onChange={handleChange}
                />
            </div>
            <button 
                type="submit" 
                disabled={loading}
                className={loading ? 'submit-button disabled' : 'submit-button'}
            >
                {loading ? "Submitting..." : "Submit"}
            </button>
        </form>
    );
};

export default NearMissForm;